import React, { Fragment } from 'react';
import { Card, CardBody, Button } from 'reactstrap';
import styled from "styled-components";
const OpitionDiv = styled.div`
display:flex;
align-items: center;
.chat-options{
padding: 6px;
width: auto;
border-radius: 10px;
margin-right: 8px;
text-align: center;
}
.chat-options:hover{
  cursor: pointer;
}`;

const ChatMessageItems = ({ item, colors }) => {
    const element1 = JSON.parse(item.text);
    return (
        <Fragment>
            <OpitionDiv className="d-flex justify-content-center"
            > {element1.buttons.map((e) => {
                return (
                    <div className="chat-options"
                        style={{
                            backgroundColor: colors.suggestionBackground,
                            color: colors.suggestionText
                        }}>
                        <span>{e}</span>
                    </div>
                );
            })}
            </OpitionDiv>
        </Fragment>
    );
};

export default ChatMessageItems;